import { Link } from "react-router-dom";

const MetaTrader4MobileContentThree = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Trade Anytime, From Any Device</h2>
              <p>
                MetaTrader 4 Mobile is available for iOS and Android, ensuring
                traders never lose access to their accounts or market
                opportunities. Whether you’re at your desk or on the go, the MT4
                app syncs seamlessly with your desktop and web platforms for a
                unified trading experience. Enjoy real-time price updates,
                advanced charting tools, and instant trade execution at your
                fingertips. With full account management on mobile, you stay
                connected and in control no matter where you are.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Download for iOS / Android
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/platforms/meta_trader_4_mobile/meta_trader_4_mobile_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader4MobileContentThree;
